import _ from 'lodash'
import React, { useRef, useState } from 'react'
import { Row, Button, Input, Form, Col, Modal, message, notification } from 'antd'
import { JSEncrypt } from "jsencrypt";
import CryptoJs from 'crypto-js'
import { Icon } from '@ant-design/compatible'
import { Store } from 'antd/es/form/interface'
import { http, routeUtils, UdModal, UdModalForm, useMount, useSetState, aesEncrypt, createLoginMd5Key } from '@ud/admin-framework'
import { ITokenData } from '../../typings'
import { appStore } from '../../stores/appStore'
import ResetPassword from './ResetPassword'
import SloganImg from './slogan.png'
import './Login.less'
import QrCodeLogin from './QrCodeLogin'
import { DesktopOutlined, QrcodeOutlined } from '@ant-design/icons'
import {cryptoAes} from '../../utils/cryptoAes';

const { confirm } = Modal

/**
 * 
 * 关于cas这块，本地是无法进行联调的。需要发布到测试环境上进行联调。
 * 因为服务端(https)会设置cookies，而本地则是http，受到浏览器安全限制无法设置。
 * 
 */

const Login: React.FC = () => {
  const qs = useRef<{ service?: string }>({})
  const [state, setState] = useSetState({
    verifyCode: {} as any,
    verifyCodeLoading: true,
    logining: false,
    visible: false
  })


  let DEVICE_ID: any = ''
  if (localStorage.getItem('DEVICE_ID')) {
    DEVICE_ID = localStorage.getItem('DEVICE_ID')
  } else {
    DEVICE_ID = '' + (Math.random() * 10000).toFixed(0) + new Date().valueOf()
    localStorage.setItem('DEVICE_ID', DEVICE_ID)
  }

  const [loginType, setLoginType] = useState<'ACCOUNT' | 'QRCODE'>('ACCOUNT')

  useMount(() => {
    qs.current = routeUtils.searchStringToObject(window.location.search, { service: '' })
    // 由于长期未活跃退出的，显示 提示信息
    if (window.sessionStorage.getItem('uaaActiveTimeout')) {
      notification.warning({
        message: '由于长时间未操作，系统已将您自动登出',
        duration: null
      })
      window.sessionStorage.removeItem('uaaActiveTimeout')
    }
    getVerifyCode()
  })

  // 发送手机验证吗
  const getVerifyCode = () => {
    setState({ verifyCodeLoading: true })
    http.get<IVerifyCode>('/api/uaa/uaa/sso/ssoCode', { params: { deviceId: DEVICE_ID } }).then(res => {
      setState({ verifyCode: res.data })
    }).finally(() => {
      setState({ verifyCodeLoading: false })
    })
  }

  const openResetPasswordModal = () => {
    setState({ visible: true })
  }

  const closeResetPasswordModal = (mode: any) => {
    setState({ visible: mode })
  }

  // 修改密码
  const editPassword = (token: string) => {
    UdModal.open({
      title: '修改密码',
      maskClosable: false,
      content: <UdModalForm items={[
        { label: '旧密码', name: 'oldPassword', required: true, render: <Input.Password /> },
        { label: '新密码', name: 'newPassword', required: true, render: <Input.Password /> },
        {
          label: '确认密码', name: 'confirmPassword', required: true, render: <Input.Password />, rules: [({ getFieldValue }) => ({
            validator(rule, value) {
              if (!value || getFieldValue('newPassword') === value) {
                return Promise.resolve()
              }
              return Promise.reject('密码不一致')
            },
          }),]
        },
      ]} />,
      onOk: (values) => {
        values.token = token
        return http.post('/manage/v1/user/updatePasswordByTokenAndOldPassword?deviceId=' + DEVICE_ID, values).then((res) => {
          message.success('密码修改成功,请重新登陆')
        })
      }
    })
  }

  const handleParams = (values: Store) => {
    // AES ECB PKCS5_PADDING加密
    const publicKey = createLoginMd5Key(values.vercode)
    const hexEncoded = aesEncrypt(values.password, publicKey)
    const params = {
      username: values.username,
      password: hexEncoded,
      uuid: state.verifyCode.uuid,
      vercode: values.vercode,
      // encryptedPassword: rawPassword
    }
    return params

  }

  // 获取用户信息
  const getTicket = (values: Store) => {
    const params = handleParams(values)
    setState({ logining: true })
    http.post<ISSOLoginRes>('/api/uaa/uaa/sso/ssoLogin?deviceId=' + DEVICE_ID, params, { withCredentials: true }).then(res => {
      const todoAction = _.get(res.data, 'todoActions[0]', null)
      const token = res.data.token
      if (!todoAction) {
        getToken(res.data.ticket)
      } else if (todoAction) {
        setState({ logining: false })
        confirm({
          title: todoAction.msg,
          okText: '确定',
          cancelText: '取消',
          onOk: () => {
            editPassword(token)
          },
          onCancel: () => {
            if (todoAction.code === '152908') {
              getToken(res.data.ticket)
            }
          }
        })
      }
    }, res => {
      setState({ logining: false })
      getVerifyCode()
    })
  }

  // 获取token并登录
  const getToken = (ticket: string) => {
    http.get<ITokenData>('/login', { params: { ticket, deviceId: DEVICE_ID } }).then(res => {
      appStore.setToken(res.data)
      getJumpUrl().then(url => {
        window.location.href = url
      })
    }).catch(() => {
      setState({ logining: false })
    })
  }

  // 获取初始页面
  const getJumpUrl = () => {
    return new Promise<string>((resolve) => {
      if (qs.current.service) {
        http.get('/cas/whiteServices').then(res => {
          for (const item of res.data) {
            if (qs.current.service?.startsWith(item)) {
              resolve(http.defaults.baseURL + '/cas/login?service=' + qs.current.service)
              return
            }
          }
          resolve('./index.html')
        }).catch(() => {
          resolve('./index.html')
        })
      } else {
        resolve('./index.html')
      }
    })
  }

  const onQrCodeLogin = (data: any) => {
    appStore.setToken(data)
    getJumpUrl().then(url => {
      window.location.href = url
    })
  }

  return (
    <div className="page-login">
      <div className="login-header">
        < div className="logo" >
          <img src="image/logo.png" alt="1919管理中心" />
          <div className="logo-text">1919管理平台</div>
        </div >
      </div >
      <div className="login-body">
        <div className="login-slogan">
          <img src={SloganImg} alt="加载中" />
        </div>
        <div className="login-form-wrap">
          <div className="warp-title">
            <span>欢迎使用1919管理平台</span>
            {
              loginType === 'ACCOUNT' &&
              // ''
              <QrcodeOutlined className='type-change-icon' onClick={() => { setLoginType('QRCODE') }} />
            }
            {
              loginType === 'QRCODE' &&
              <DesktopOutlined className='type-change-icon' onClick={() => {
                setLoginType('ACCOUNT')
                getVerifyCode()
              }} />
            }
          </div>
          {
            loginType === 'ACCOUNT' &&
            <Form onFinish={getTicket} initialValues={{
              username: process.env.REACT_APP_ENV === 'local' ? 'uaaTSA' : '',
              password: process.env.REACT_APP_ENV === 'local' ? 'Admin@1919.cn' : '',
            }}>
              <Form.Item name="username" hasFeedback rules={[{ required: true, message: '用户名不能为空' }]} >
                <Input prefix={<Icon type='user' />} placeholder='请输入用户名' allowClear />
              </Form.Item>
              <Form.Item name="password" hasFeedback rules={[{ required: true, message: '请输入登录密码' }]}>
                <Input.Password type='password' prefix={<Icon type='lock' />} placeholder='请输入登录密码' allowClear />
              </Form.Item>
              <Row>
                <Col span={16}>
                  <Form.Item name="vercode" hasFeedback rules={[{ required: true, message: '请输入验证码' }]}>
                    <div className={'verify'}>
                      <Input prefix={<Icon type="security-scan" />} placeholder='请输入验证码' maxLength={4} allowClear />
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <img
                    // style={{ width: '100%', height: '31.33px', cursor: 'pointer' }}
                    title="点击更换验证码" alt="验证码"
                    onClick={() => getVerifyCode()}
                    src={(state.verifyCode && state.verifyCode.srcBase64) || undefined}
                  />
                </Col>
              </Row>
              <div className='password-row'>
                <a onClick={() => openResetPasswordModal()}>忘记密码?</a>
              </div>
              <Row>
                <Button type="primary" htmlType="submit"
                  disabled={state.verifyCodeLoading} loading={state.logining}>登 录</Button>
              </Row>
            </Form>
          }

          {
            loginType === 'QRCODE' &&
            <QrCodeLogin onSuccess={(data: any) => {
              onQrCodeLogin(data)  // TODO:
            }} />
          }

        </div>
      </div>
      <ResetPassword visiblestatus={state.visible} cancel={(mode: any) => closeResetPasswordModal(mode)} />
    </div >
  )
}
interface IVerifyCode {
  uuid: string
  srcBase64: string
}

interface ISSOLoginRes {
  token: string
  ticket: string
  todoActions: any[]
}

export default Login
